module.exports = __webpack_public_path__ + "static/media/copy-icon.448912d2.svg";